export default __webpack_public_path__ + "static/Montserrat-Bold-09aa44bfee794bd5211e30aca4fdbf92.ttf";